import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { getResolvedEndpoint } from '@/api/utils/getResolvedEndpoint';
import { handleApiCall } from '@/api/utils/handleApiCall';
import { MutationStateFns } from '@/api/utils/mutation';
import { Id } from '@/api/utils/sql';
import { useAuth } from '@/context/AuthProvider';

export type ApiResponse_TrackShareClick = {
  success: boolean;
  target_type: string;
  target_id: Id;
  metadata: Record<string, unknown>;
};

const METHOD = 'POST';
const ENDPOINT = 'negotiation/share/:shortCode/click';

export const useTrackShareClick = (
  stateFns?: MutationStateFns<ApiResponse_TrackShareClick>
) => {
  const { session } = useAuth();

  return useMutation({
    mutationFn: async (shortCode: string) =>
      handleApiCall<ApiResponse_TrackShareClick>(
        session, // Keep session for authenticated users, but endpoint accepts null too
        METHOD,
        getResolvedEndpoint(ENDPOINT, { shortCode }),
        undefined
      ),
    onSuccess: (data) => {
      stateFns?.onSuccess?.(data);
    },
    onError: (err: AxiosError) => {
      // Error tracking is optional, don't show to user
      stateFns?.onError?.(err);
    },
  });
};